import { ICroppingApplication, ICroppingPlan } from "./types";

export class AppVm {

    static createViewModels(plans: ICroppingPlan[]) {

        return plans.map(p => {

            let applications = p.applications.map(a => new AppVm(p, a));

            return {

                plan: p,
                applications: applications,
                visible: !p.plan.Restricted
            };

        });


    }

    constructor(public plan: ICroppingPlan, public app: ICroppingApplication) {
    }

    contributesNutrient(nutrient: string): boolean {
        return this.app.contrib && (!!this.app.contrib[nutrient]);
    }

    getClosingReq(nutrient: string): number {

        if (this.app.closingReq) {
            return this.app.closingReq[nutrient];
        }

    }

}
